module.exports = {
    RECEIVE_HYDROMETRIC_STATION: 'RECEIVE_HYDROMETRIC_STATION',
    RECEIVE_ALL_HYDROMETRIC_STATIONS: 'RECEIVE_ALL_HYDROMETRIC_STATIONS',
    RECEIVE_HYDROMETRY_THRESHOLDS: 'RECEIVE_HYDROMETRY_THRESHOLDS',

    // TODO : Move this list on other global constant file
    MONTHS: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
    ALL: 'ALL',
    MAX: 'MAX',
    MIN: 'MIN',
    SUM: 'SUM',
    AVERAGE: 'AVERAGE',
    HYDROMETER_HEIGHT_TYPE: 4,
    TIDE_GAUGE_TYPE: 4,

    // ---------------------
    WINDOW: 'window',
    POINT: 'point',
    MOVING: 'moving',
    NEWPOINT: 'newPoint',
    VALIDATION: 'validation',
    HISTORIC: 'historic',
    PURGE: 'purge',
    IMPORT: 'import',
    COMPENSATION: 'compensation',
    CORRECTION: 'correction',
    OPTIONS: 'options',
    THRESHOLDS: 'thresholds',
    EVENT: 'event',
    AUTO: 'auto',
    MANUAL: 'manual',
    RESET: 'reset',
    DELETE: 'delete',
    // ---------------------

    // ---------------------

    HYDRO_IMPORT_TYPE: {
        HYDRO_PORTAIL: 'HYDRO',
        EMPTY: 'EMPTY',
    },
    HYDRO_TYPEID: {
        SAMPLE: -2,
        HEIGHT: 4,
        FLOW: 5,
    },
    HYDRO_L_STORAGE: {
        DISPLAY_MODES_DASHBOARD: 'HYDRO_DISPLAY_MODES_DASHBOARD',
        STATUS_QUALIF_DASHBOARD: 'HYDRO_STATUS_QUALIF_DASHBOARD',
        DISPLAY_MODES_SUIVI: 'HYDRO_DISPLAY_MODES_SUIVI',
        STATUS_QUALIF_SUIVI: 'HYDRO_STATUS_QUALIF_SUIVI',
        TIME_VALIDATION: 'HYDRO_TIME_VALIDATION',
        TIME_OTHER_VALIDATION: 'HYDRO_TIME_OTHER_VALIDATION',
    },

    HYDRO_MEASURE_COTE: {
        NGF: 1,
        HEIGHT: 2,
    },
    HYDRO_DISPLAY_COTE: 'HYDRO_DISPLAY_COTE',
    HYDRO_TAB_DISPLAY_MODES: 'HYDRO_TAB_DISPLAY_MODES',
}